/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ActionResource { 
    time: string;
    result: string;
    user: string;
    insertionMethod: string;
    note: string;
}

